export const NS_GAME_STATE = 'GameState';
export const NS_TURN_STATE = 'TurnState';
export const NS_LAYER_STATE = 'LayerState';

